(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ca-finder"] && !Shopify.designMode) return;
  try {
    
function initCaFinder(){const root=document.querySelector('#quiz-section');if(!root||root.dataset.initialized)return;root.dataset.initialized='true';
const caFinderQuestions = [
            { label: 'Who are you shopping for?', key: 'recipient', options: ['Myself', 'My pastor', 'A friend or family member'] },
            { label: 'What fits their everyday life?', key: 'category', options: ['Tees', 'Hoodies', 'Drinkware', 'Journals', 'Help me choose'] },
            { label: 'Which message would you like to share?', key: 'theme', options: ['The Five Solas', 'Post Tenebras Lux', 'Semper Reformanda', 'Simul Justus et Peccator', 'Mortify Sin', 'Help me choose'] }
        ];
        let caFinderStep = 0;
        let caFinderAnswers = {};
        function caFinderButton(label, action, secondary = false) {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = secondary ? 'ca-finder-back' : 'ca-finder-option';
            button.textContent = label;
            button.addEventListener('click', action);
            return button;
        }
        function caFinderHeading(text) {
            const heading = document.createElement('h3');
            heading.textContent = text;
            heading.tabIndex = -1;
            return heading;
        }
        function caFinderDirection(answers) {
            const recipient = answers.recipient;
            const category = answers.category === 'Help me choose' ? (recipient === 'My pastor' ? 'Journals' : 'Tees') : answers.category;
            const theme = answers.theme === 'Help me choose' ? 'The Five Solas' : answers.theme;
            const reasons = {Tees: 'Wear the message in everyday life.', Hoodies: 'Choose a layer that carries a meaningful message.', Drinkware: 'Bring a reminder of faith to a daily routine.', Journals: 'Give notes, study, and reflection a dedicated place.'};
            return {category, theme, reason: reasons[category], recipient: recipient === 'Myself' ? 'For you' : recipient === 'My pastor' ? 'For your pastor' : 'For someone you care about'};
        }
        function caRenderFinder(moveFocus = false) {
            const content = document.getElementById('ca-finder-content');
            const nav = document.getElementById('ca-finder-navigation');
            content.replaceChildren(); nav.replaceChildren();
            let heading;
            if (caFinderStep < 3) {
                const question = caFinderQuestions[caFinderStep];
                document.getElementById('ca-finder-progress-label').textContent = `QUESTION ${caFinderStep + 1} OF 3`;
                document.getElementById('ca-finder-progress-count').textContent = `0${caFinderStep + 1} / 03`;
                heading = caFinderHeading(question.label); content.append(heading);
                const options = document.createElement('div'); options.className = 'ca-finder-options';
                question.options.forEach(option => {
                    const button = caFinderButton(option, () => {
                        caFinderAnswers[question.key] = option; caFinderStep++; caRenderFinder(true);
                    });
                    button.setAttribute('aria-pressed', String(caFinderAnswers[question.key] === option));
                    options.append(button);
                });
                content.append(options);
                if (caFinderStep > 0) nav.append(caFinderButton('← Back', () => {caFinderStep--; caRenderFinder(true);}, true));
            } else {
                const match = caFinderDirection(caFinderAnswers);
                document.getElementById('ca-finder-progress-label').textContent = 'YOUR SHOPPING DIRECTION';
                document.getElementById('ca-finder-progress-count').textContent = '03 / 03';
                heading = caFinderHeading(`Explore ${match.category}`); content.append(heading);
                const context = document.createElement('p'); context.className = 'ca-finder-context'; context.textContent = match.recipient; content.append(context);
                const theme = document.createElement('p'); theme.className = 'ca-finder-theme'; theme.textContent = `Design to explore: ${match.theme}`; content.append(theme);
                const reason = document.createElement('p'); reason.className = 'ca-finder-reason'; reason.textContent = match.reason; content.append(reason);
                const categoryLink = document.createElement('a'); categoryLink.href = {Tees:'/collections/shirts',Hoodies:'/collections/hoodies',Drinkware:'/collections/gifts-and-drinkware',Journals:'/collections/journals'}[match.category]; categoryLink.className = 'ca-finder-result-link'; categoryLink.textContent = `Explore ${match.category} on Our Store ↗`; content.append(categoryLink);
                const designLink = document.createElement('a'); designLink.href = '#convictions'; designLink.className = 'ca-finder-design-link'; designLink.textContent = 'Explore the Designs ↗'; content.append(designLink);
                nav.append(caFinderButton('← Change answers', () => {caFinderStep = 2; caRenderFinder(true);}, true));
                nav.append(caFinderButton('Start again', () => {caFinderStep = 0; caFinderAnswers = {}; caRenderFinder(true);}, true));
            }
            if (moveFocus) heading.focus({preventScroll: true});
        }
        caRenderFinder();
    
}
initCaFinder();document.addEventListener('shopify:section:load',initCaFinder);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
